import { render, staticRenderFns } from "./Meeting.vue?vue&type=template&id=2535d854&scoped=true&lang=pug&"
import script from "./Meeting.vue?vue&type=script&lang=js&"
export * from "./Meeting.vue?vue&type=script&lang=js&"
import style0 from "./Meeting.vue?vue&type=style&index=0&id=2535d854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2535d854",
  null
  
)

export default component.exports